import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { FETCH_ACTIVE_DOCTOR_SHIFTS } from "constants/doctorShift.constants";
import axios from "axios";
import {  getActiveDoctorShiftSuccess  } from "actions/doctorShift.action";
import { showErrors, stopLoader } from "actions/general.action";

// get shift categories
const fetchActiveDoctorShiftsRequest = async () => {
  let link = "/api/v1/super_admin/doctor_shifts/active_shifts?group_by=shift_category_id";
  //return axios.get("/api/v1/doctor_shifts/active_shifts");
  return axios.get(link); 

};

function* fetchDoctorActiveShifts() {
  try {
    const result = yield call(fetchActiveDoctorShiftsRequest);
    if (result.message) {
      yield put(showErrors(result.message));
    } else {
      yield put(getActiveDoctorShiftSuccess (result.data.data));
    }
  } catch (error) {
    yield put(showErrors(error.message));
  }
}
export function* forkFetchDoctorActiveShifts() {
  yield takeEvery(FETCH_ACTIVE_DOCTOR_SHIFTS, fetchDoctorActiveShifts);
}

export default function* rootSaga() {
  yield all([
    fork(forkFetchDoctorActiveShifts),
    // fork(forkUpdatePack),
    // fork(forkCreatePack),
    // fork(forkDeletePack),
  ]);
}